module.exports = "/_next/static/images/icon_youtube-180af6c3c41a262d1d59167946225388.svg";